import { useContent } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { TableCellDiv } from 'src/core/ui/TableCellDiv';
import { IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { TICKET_TYPE_TO_CID } from 'src/utils/constants/contentIdMaps';
import { getTicketTypeIcon } from 'src/utils/ticketTypeUtils';

import { SaleWithEvent } from '../SalesTable.type';
import * as styles from './SoldQuantityTicketTypeCell.css';

export const SoldQuantityTicketTypeCell = ({
  sale: {
    sale: { ticketType, qtySold },
  },
  useV2Style = false,
}: {
  sale: SaleWithEvent;
  useV2Style?: boolean;
}) => {
  const ticketTypeIcon = getTicketTypeIcon(
    ticketType,
    IconsFill.currentColor,
    false, // showIconTitle - we have our own title
    '16px' // size
  );
  const quantitySoldDisplay = `x${qtySold}`;
  const ticketTypeText = useContent(
    ticketType ? TICKET_TYPE_TO_CID[ticketType] : ContentId.EmptyContent
  );

  return (
    <TableCellDiv
      align="left"
      showTooltip={false}
      style={{ height: '100%' }}
      wrap={useV2Style ? 'wrap' : undefined}
    >
      <Stack
        className={
          useV2Style
            ? styles.soldQuantityTicketTypeContainerV2
            : styles.soldQuantityTicketTypeContainer
        }
        direction="row"
        gap="s"
        title={`${ticketTypeText} ${quantitySoldDisplay}`}
      >
        {ticketTypeIcon}
        <span style={{ color: vars.color.textStrong }}>
          {quantitySoldDisplay}
        </span>
      </Stack>
    </TableCellDiv>
  );
};
